import { changePassword, forceLogout, login, logout } from '@redux/actions';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AuthState = {
  jwt: '',
  user: null,
  config: {},
};

const removeAuth = (state: AuthState) => {
  state.jwt = '';
  state.user = null;
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(forceLogout, removeAuth)
      .addCase(login.fulfilled, (state, { payload }) => {
        if (!payload.user.forceChangePassword) {
          state.jwt = payload.jwt;
          state.user = payload.user;
          if (payload.user.id !== state.config?.accountId) {
            state.config = {
              accountId: payload.user.id,
              event: { time: 30, enabled: true },
            };
          }
        }
      })
      .addCase(logout.fulfilled, removeAuth)
      .addCase(changePassword.fulfilled, removeAuth);
  },
});

// export const { logout } = authSlice.actions;

export default authSlice.reducer;
